import AbstractSymbolSpineAnimationsConfig from '../../vendor_core/core/src/baseConfigs//AbstractSymbolSpineAnimationsConfig';
import ISymbolSpineAnimConfig from '../../vendor_core/core/src/managers/contracts/configurations/ISymbolSpineAnimConfig';
import ISpineAnimSkinConfig from '../../vendor_core/core/src/managers/contracts/configurations/spine_anim/ISpineAnimSkinConfig';
import ISpineAnimStateConfig from '../../vendor_core/core/src/managers/contracts/configurations/spine_anim/ISpineAnimStateConfig';


class SymbolSpineAnimationsConfig extends AbstractSymbolSpineAnimationsConfig implements ISymbolSpineAnimConfig {
    name: string = "baloon";
    hasSkins: boolean = true;
    defaultSkin: string = "default";
    activeSkin: string = "default";
    visible: boolean = true;
    states: ISpineAnimStateConfig[] = [
        {
            name: "before_lightning",
            loop: false
        },
        {
            name: "shot_lightning",
            loop: false
        },
        {
            name: "idle_lightning",
            loop: false
        },
        {
            name: "idle",
            loop: true
        },
        {
            name: "land",
            loop: false
        },
        {
            name: "land2",
            loop: false
        },
        {
            name: "land3",
            loop: false
        },
        {
            name: "outro",
            loop: false
        },
        {
            name: "floating_up",
            loop: false
        },
        {
            name: "scale_idle",
            loop: false
        },
        {
            name: "scale_intro",
            loop: false
        },
        {
            name: "scale_outro",
            loop: false
        },
        {
            name: "star_idle",
            loop: true
        },
        {
            name: "star_land",
            loop: false
        },
        {
            name: "star_floating_up",
            loop: false
        },
        {
            name: "star_scale_idle",
            loop: false
        },
        {
            name: "star_scale_on",
            loop: false
        },
        {
            name: "star_scale_off",
            loop: false
        },
        {
            name: "star_scale_idle_shine",
            loop: false
        },
        {
            name: "star_scale_on_shine",
            loop: false
        },
        {
            name: "star_scale_off_shine",
            loop: false
        },
        {
            name: "star_scale_rotate_shine",
            loop: false
        },
        {
            name: "star_scale_demo",
            loop: false
        },
        {
            name: "star_tornado_mode",
            loop: true
        },
    ];
    skins: ISpineAnimSkinConfig[] = [
        {
            name: "default",
            states: []
        },
        {
            name: "blue",
            states: ["before_lightning", "floating_up", "idle", "idle_lightning", "land", "land2", "land3", "outro", "scale_idle", "scale_intro", "scale_outro", "shot_lightning"],
            chainingStates: [
                {
                    name: "thunder",
                    states: ["idle_lightning", "before_lightning"],
                    entryPoint: "idle_lightning",
                    loop: false,
                    hideOnComplete: false,
                    hasStaticStateOnComplete: false,
                    hasLoopStateOnComplete: true,
                    loopStateOnComplete: "before_lightning"
                },
                {
                    name: "land_chain",
                    states: ["land", "idle"],
                    entryPoint: "land",
                    loop: false,
                    hideOnComplete: false,
                    hasStaticStateOnComplete: false,
                    hasLoopStateOnComplete: true,
                    loopStateOnComplete: "idle"
                },
                {
                    name: "scale_up",
                    states: ["scale_intro", "scale_idle"],
                    entryPoint: "scale_intro",
                    loop: false,
                    hideOnComplete: false,
                    hasStaticStateOnComplete: false,
                    hasLoopStateOnComplete: true,
                    loopStateOnComplete: "scale_idle"
                },
                {
                    name: "scale_down",
                    states: ["scale_outro", "idle"],
                    entryPoint: "scale_outro",
                    loop: false,
                    hideOnComplete: false,
                    hasStaticStateOnComplete: false,
                    hasLoopStateOnComplete: true,
                    loopStateOnComplete: "idle"
                },
            ],
            playDefault: true,
            defaultState: "idle"
        },
        {
            name: "red",
            states: ["before_lightning", "floating_up", "idle", "idle_lightning", "land", "land2", "land3", "outro", "scale_idle", "scale_intro", "scale_outro", "shot_lightning"],
            chainingStates: [
                {
                    name: "land_chain",
                    states: ["land", "idle"],
                    entryPoint: "land",
                    loop: false,
                    hideOnComplete: false,
                    hasStaticStateOnComplete: false,
                    hasLoopStateOnComplete: true,
                    loopStateOnComplete: "idle"
                },
                {
                    name: "thunder",
                    states: ["idle_lightning", "before_lightning"],
                    entryPoint: "idle_lightning",
                    loop: false,
                    hideOnComplete: false,
                    hasStaticStateOnComplete: false,
                    hasLoopStateOnComplete: true,
                    loopStateOnComplete: "before_lightning"
                },
                {
                    name: "scale_up",
                    states: ["scale_intro", "scale_idle"],
                    entryPoint: "scale_intro",
                    loop: false,
                    hideOnComplete: false,
                    hasStaticStateOnComplete: false,
                    hasLoopStateOnComplete: true,
                    loopStateOnComplete: "scale_idle"
                },
                {
                    name: "scale_down",
                    states: ["scale_outro", "idle"],
                    entryPoint: "scale_outro",
                    loop: false,
                    hideOnComplete: false,
                    hasStaticStateOnComplete: false,
                    hasLoopStateOnComplete: true,
                    loopStateOnComplete: "idle"
                },
            ],
            playDefault: true,
            defaultState: "idle"
        },
        {
            name: "green",
            states: ["before_lightning", "floating_up", "idle", "idle_lightning", "land", "land2", "land3", "outro", "scale_idle", "scale_intro", "scale_outro", "shot_lightning"],
            chainingStates: [
                {
                    name: "land_chain",
                    states: ["land2", "idle"],
                    entryPoint: "land2",
                    loop: false,
                    hideOnComplete: false,
                    hasStaticStateOnComplete: false,
                    hasLoopStateOnComplete: true,
                    loopStateOnComplete: "idle"
                },
                {
                    name: "thunder",
                    states: ["idle_lightning", "before_lightning"],
                    entryPoint: "idle_lightning",
                    loop: false,
                    hideOnComplete: false,
                    hasStaticStateOnComplete: false,
                    hasLoopStateOnComplete: true,
                    loopStateOnComplete: "before_lightning"
                },
                {
                    name: "scale_up",
                    states: ["scale_intro", "scale_idle"],
                    entryPoint: "scale_intro",
                    loop: false,
                    hideOnComplete: false,
                    hasStaticStateOnComplete: false,
                    hasLoopStateOnComplete: true,
                    loopStateOnComplete: "scale_idle"
                },
                {
                    name: "scale_down",
                    states: ["scale_outro", "idle"],
                    entryPoint: "scale_outro",
                    loop: false,
                    hideOnComplete: false,
                    hasStaticStateOnComplete: false,
                    hasLoopStateOnComplete: true,
                    loopStateOnComplete: "idle"
                },
            ],
            playDefault: true,
            defaultState: "idle"
        },
        {
            name: "orange",
            states: ["before_lightning", "floating_up", "idle", "idle_lightning", "land", "land2", "land3", "outro", "scale_idle", "scale_intro", "scale_outro", "shot_lightning"],
            chainingStates: [
                {
                    name: "land_chain",
                    states: ["land2", "idle"],
                    entryPoint: "land2",
                    loop: false,
                    hideOnComplete: false,
                    hasStaticStateOnComplete: false,
                    hasLoopStateOnComplete: true,
                    loopStateOnComplete: "idle"
                },
                {
                    name: "thunder",
                    states: ["idle_lightning", "before_lightning"],
                    entryPoint: "idle_lightning",
                    loop: false,
                    hideOnComplete: false,
                    hasStaticStateOnComplete: false,
                    hasLoopStateOnComplete: true,
                    loopStateOnComplete: "before_lightning"
                },
                {
                    name: "scale_up",
                    states: ["scale_intro", "scale_idle"],
                    entryPoint: "scale_intro",
                    loop: false,
                    hideOnComplete: false,
                    hasStaticStateOnComplete: false,
                    hasLoopStateOnComplete: true,
                    loopStateOnComplete: "scale_idle"
                },
                {
                    name: "scale_down",
                    states: ["scale_outro", "idle"],
                    entryPoint: "scale_outro",
                    loop: false,
                    hideOnComplete: false,
                    hasStaticStateOnComplete: false,
                    hasLoopStateOnComplete: true,
                    loopStateOnComplete: "idle"
                },
            ],
            playDefault: true,
            defaultState: "idle"
        },
        {
            name: "yellow",
            states: ["before_lightning", "floating_up", "idle", "idle_lightning", "land", "land2", "land3", "outro", "scale_idle", "scale_intro", "scale_outro", "shot_lightning"],
            chainingStates: [
                {
                    name: "land_chain",
                    states: ["land3", "idle"],
                    entryPoint: "land3",
                    loop: false,
                    hideOnComplete: false,
                    hasStaticStateOnComplete: false,
                    hasLoopStateOnComplete: true,
                    loopStateOnComplete: "idle"
                },
                {
                    name: "thunder",
                    states: ["idle_lightning", "before_lightning"],
                    entryPoint: "idle_lightning",
                    loop: false,
                    hideOnComplete: false,
                    hasStaticStateOnComplete: false,
                    hasLoopStateOnComplete: true,
                    loopStateOnComplete: "before_lightning"
                },
                {
                    name: "scale_up",
                    states: ["scale_intro", "scale_idle"],
                    entryPoint: "scale_intro",
                    loop: false,
                    hideOnComplete: false,
                    hasStaticStateOnComplete: false,
                    hasLoopStateOnComplete: true,
                    loopStateOnComplete: "scale_idle"
                },
                {
                    name: "scale_down",
                    states: ["scale_outro", "idle"],
                    entryPoint: "scale_outro",
                    loop: false,
                    hideOnComplete: false,
                    hasStaticStateOnComplete: false,
                    hasLoopStateOnComplete: true,
                    loopStateOnComplete: "idle"
                },
            ],
            playDefault: true,
            defaultState: "idle"
        },
        {
            name: "purple",
            states: ["before_lightning", "floating_up", "idle", "idle_lightning", "land", "land2", "land3", "outro", "scale_idle", "scale_intro", "scale_outro", "shot_lightning"],
            chainingStates: [
                {
                    name: "land_chain",
                    states: ["land3", "idle"],
                    entryPoint: "land3",
                    loop: false,
                    hideOnComplete: false,
                    hasStaticStateOnComplete: false,
                    hasLoopStateOnComplete: true,
                    loopStateOnComplete: "idle"
                },
                {
                    name: "thunder",
                    states: ["idle_lightning", "before_lightning"],
                    entryPoint: "idle_lightning",
                    loop: false,
                    hideOnComplete: false,
                    hasStaticStateOnComplete: false,
                    hasLoopStateOnComplete: true,
                    loopStateOnComplete: "before_lightning"
                },
                {
                    name: "scale_up",
                    states: ["scale_intro", "scale_idle"],
                    entryPoint: "scale_intro",
                    loop: false,
                    hideOnComplete: false,
                    hasStaticStateOnComplete: false,
                    hasLoopStateOnComplete: false,
                    loopStateOnComplete: "scale_idle"
                },
                {
                    name: "scale_down",
                    states: ["scale_outro", "idle"],
                    entryPoint: "scale_outro",
                    loop: false,
                    hideOnComplete: false,
                    hasStaticStateOnComplete: false,
                    hasLoopStateOnComplete: true,
                    loopStateOnComplete: "idle"
                },
            ],
            playDefault: true,
            defaultState: "idle"
        },
        {
            name: "star",
            states: [
                "star_idle",
                "star_land",
                "star_floating_up",
                "star_scale_idle",
                "star_scale_on",
                "star_scale_off",
                "star_scale_idle_shine",
                "star_scale_on_shine",
                "star_scale_off_shine",
                "star_scale_rotate_shine",
                "star_tornado_mode"
            ],
            chainingStates: [
                {
                    name: "star_scale_on_idle",
                    states: ["star_scale_on", "star_idle"],
                    entryPoint: "star_scale_on",
                    loop: false,
                    hideOnComplete: false,
                    hasStaticStateOnComplete: false,
                    hasLoopStateOnComplete: true,
                    loopStateOnComplete: "star_idle"
                },
                {
                    name: "star_land_chain",
                    states: ["star_land", "star_idle"],
                    entryPoint: "star_land",
                    loop: false,
                    hideOnComplete: false,
                    hasStaticStateOnComplete: false,
                    hasLoopStateOnComplete: true,
                    loopStateOnComplete: "star_idle"
                },
                {
                    name: "star_scale_down",
                    states: ["star_scale_off", "star_idle"],
                    entryPoint: "star_scale_off",
                    loop: false,
                    hideOnComplete: false,
                    hasStaticStateOnComplete: false,
                    hasLoopStateOnComplete: true,
                    loopStateOnComplete: "star_idle"
                },
                {
                    name: "star_rotate",
                    states: ["star_scale_on_shine", "star_scale_rotate_shine", "star_idle"],
                    entryPoint: "star_scale_on_shine",
                    loop: false,
                    hideOnComplete: false,
                    hasStaticStateOnComplete: false,
                    hasLoopStateOnComplete: true,
                    loopStateOnComplete: "star_idle"
                },
                {
                    name: "star_back_from_rotate",
                    states: ["star_scale_off_shine", "star_scale_idle"],
                    entryPoint: "star_scale_off_shine",
                    loop: false,
                    hideOnComplete: false,
                    hasStaticStateOnComplete: false,
                    hasLoopStateOnComplete: false,
                    loopStateOnComplete: "star_scale_idle"
                },
            ],
            playDefault: true,
            defaultState: "star_idle"
        },
    ];
}

export default new SymbolSpineAnimationsConfig()
